<template>
	<footer id="footer">
		<div class="blocks">
			<section
				v-for="(block, n) in translatedBlocks"
				:key="`block_${currentLanguage}_${n}`"
				:class="{
					is_open: accordions.indexOf(n) !== -1,
					is_accordion: block.header.length,
				}"
			>
				<h3 @click="toggleAccordion(n)">{{ block.header }}</h3>
				<div class="content" :ref="block.header ? 'accordion' : 'box'" v-if="block.acf_fc_layout == 'mailchimp'">
					<mailchimp-signup
						:label="block.label"
						:url="block.ajax"
						:header="block.header"
						:error="block.error_message"
						:placeholder="block.placeholder"
					/>
				</div>
				<div class="content" v-else :ref="block.header ? 'accordion' : 'box'" v-html="block.text"></div>
			</section>
			<section class="credentials">
				<p>
					© ProCoRe<br />
					<span v-for="(f, n) in translatedFooterMenu" :key="`f_meni_${n}`">
						<router-link :to="f.page.url | clearUrl">{{ f.page.title }}</router-link>
						<span v-if="n != translatedFooterMenu.length - 1"> & </span>
					</span>
					<!-- <span href="">Rechtliche Hinweise</span> & <a>Impressum</a> -->
				</p>
				<a :href="facebook" class="facebook exlude_hover" @mouseenter="onMouseEnter" @mouseleave="onMouseLeave">
					<IconFacebook />
				</a>
				<a
					v-if="twitter"
					:href="twitter"
					class="twitter exlude_hover"
					@mouseenter="onMouseEnter"
					@mouseleave="onMouseLeave"
				>
					<IconTwitter />
				</a>
				<a
					v-if="instagram"
					:href="instagram"
					class="twitter exlude_hover"
					@mouseenter="onMouseEnter"
					@mouseleave="onMouseLeave"
				>
					<IconInstagram />
				</a>
			</section>
		</div>
	</footer>
</template>

<script>
import { mapState } from "vuex";
// import LanguageSwitcher from "@/components/LanguageSwitcher";
import IconFacebook from "@/components/icons/IconFacebook";
import IconTwitter from "@/components/icons/IconTwitter";
import IconInstagram from "@/components/icons/IconInstagram";

import EventBus from "@/helpers/event-bus";
import gsap from "gsap";
import PointerHoverMixin from "@/mixins/pointerHover";
import MailchimpSignup from "@/components/MailchimpSignup.vue";

export default {
	name: "TheFooter",
	mixins: [PointerHoverMixin],
	components: {
		IconFacebook,
		IconTwitter,
		IconInstagram,
		// LanguageSwitcher,
		MailchimpSignup,
	},
	computed: {
		...mapState({
			blocks: (state) => state.site.footer,
			facebook: (state) => state.site.facebook,
			twitter: (state) => state.site.twitter,
			instagram: (state) => state.site.instagram,
			footerMenu: (state) => state.site.footerMenu,
			currentLanguage: (state) => state.site.currentLanguage,
			isLoaded: (state) => state.site.isLoaded,
		}),
		translatedBlocks() {
			return this.blocks[this.currentLanguage];
		},
		translatedFooterMenu() {
			return this.footerMenu[this.currentLanguage];
		},
	},
	data() {
		return {
			accordions: [],
		};
	},
	mounted() {
		this.addLinksListener();
	},
	updated() {
		this.addLinksListener();
	},
	methods: {
		toggleAccordion(id) {
			const index = this.accordions.indexOf(id);

			if (index === -1) {
				gsap.fromTo(this.$refs.accordion[id], 0.3, { height: 0 }, { height: "auto" });
				this.accordions.push(id);
			} else {
				this.accordions.splice(index, 1);
				gsap.to(this.$refs.accordion[id], 0.3, { height: 0 });
			}
		},
		onMouseEnter(ev) {
			const parent = ev.currentTarget;
			const icon = this.grabIcon(ev);
			EventBus.$emit(EventBus.pointer.enter, { el: icon, parent });
		},
		onMouseLeave(ev) {
			const parent = ev.currentTarget;
			const icon = this.grabIcon(ev);
			EventBus.$emit(EventBus.pointer.leave, { el: icon, parent });
		},
		grabIcon(ev) {
			const el = ev.currentTarget;
			const icon = el.getElementsByTagName("svg")[0];

			return icon;
		},
	},
};
</script>

<style lang="scss" scoped>
footer {
	position: relative;
	z-index: 3;

	@include mq($from: xl) {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
	}
}

.facebook {
	display: inline-block;
	margin-top: 20px;
	cursor: pointer;

	&::v-deep {
		svg path.bg {
			fill: #fff;
		}
	}

	&:hover {
		&::v-deep {
			svg path.bg {
				fill: $colorRed1;
			}
		}
	}
}

.twitter {
	display: inline-block;
	margin-top: 20px;
	margin-left: 10px;
	cursor: pointer;

	&::v-deep {
		svg path.bg {
			fill: #fff;
		}
	}

	&:hover {
		&::v-deep {
			svg path.bg {
				fill: $colorRed1;
			}
		}
	}
}

.blocks {
	display: flex;
	padding: 55px 0 0;
	flex-wrap: wrap;

	@include mq($from: m) {
		padding: 70px 0 55px;
	}

	@include mq($from: xl) {
		padding: 140px 0 140px;
		flex: 0 0 100%;
	}

	section {
		flex: 0 0 100%;
		overflow: hidden;

		@include mq($from: m) {
			flex: 1 1 25%;
			padding: 0 10px;

			&:first-child {
				padding-left: 0;
			}

			&:last-child {
				padding-right: 0;
			}
		}

		&.credentials {
			flex: 2 1 20%;

			@include mq($to: m) {
				padding: 25px 0;
			}
		}

		&::v-deep p {
			@include fontCopyS;

			a {
				transition: color 0.3s;
				&:hover {
					color: $colorRed1 !important;
				}
				// @include linkUnderline(#fff);
			}
		}

		h3 {
			@include fontCopy();
		}
	}
}

section.is_accordion {
	@include mq($to: m) {
		border-bottom: 1px solid $colorBeige2;

		&:first-of-type {
			// FIXME replace this with svg animated icon
			border-top: 1px solid $colorBeige2;
		}
	}

	h3 {
		padding: 25px 0;
		position: relative;
		// FIXME replace this with svg animated icon
		cursor: pointer;

		&:before,
		&:after {
			content: "";
			width: 18px;
			height: 2px;
			position: absolute;
			right: 2px;
			top: calc(50% - 1px);
			border-radius: 2px;
			background: #fff;
		}

		&:after {
			transform: rotate(90deg);
		}

		@include mq($from: m) {
			display: none;
			visibility: hidden;
		}
	}

	&.is_open {
		h3 {
			&:after {
				transform: rotate(0);
			}
		}
	}

	.content {
		@include mq($to: m) {
			height: 0;
			overflow: hidden;

			&::v-deep p:last-child {
				padding-bottom: 25px;
			}
		}

		@include mq($from: m) {
			height: auto !important;
		}
	}
}
</style>
